
import { defineComponent, computed } from 'vue'
import MagazineCardContent from '@/components/block/MagazineCardContent.vue'
import MagazineCardSeriesContent from '@/components/block/MagazineCardSeriesContent.vue'
export default defineComponent({
  name: 'MagazineCard',
  components: {
    MagazineCardContent,
    MagazineCardSeriesContent
  },
  props: {
    image: String,
    imageAlt: String,
    title: String,
    description: String,
    path: String,
    category: String,
    wide: Boolean,
    date: String,
    membershipOnly: Boolean,
    url: String,
    parentCategorySlug: String,
    articleIndex: {
      type: Boolean,
      default: false
    },
    showPr: Boolean
  },
  setup(props) {
    const headingClass = {
      magazineCard_heading: !props.wide,
      magazineCard_heading_wide: props.wide
    }
    // 「連載」記事一覧ページなどでレイアウト変更
    const cardComponent = computed(() =>
      props.articleIndex ? 'MagazineCardSeriesContent' : 'MagazineCardContent'
    )

    return {
      headingClass,
      cardComponent
    }
  }
})
